import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { formatNumber } from '../../../utility/formatNumber';
function RangeColumn({ value, rowSpanTags, onHoverRange, format, }) {
    return (_jsx("td", { ...rowSpanTags, ...onHoverRange, children: formatNumber(value, format) }));
}
export default memo(RangeColumn);
